import { useState, useEffect } from "react";
import {  Paper, Button, Container, Modal, Stack , Grid, Card,CardContent, Typography, Divider, CardMedia} from "@mui/material"
import firebaseConfig from "../firebase";
import { collection, getDocs, doc, deleteDoc, } from "firebase/firestore";
import { useDispatch } from "react-redux";
import WoodUpdate from "./WoodUpdate";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import "reactjs-popup/dist/index.css";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useNavigate } from "react-router-dom";
import { getFirestore } from 'firebase/firestore';



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  bgcolor: 'background.paper',
  border: '2px solid #000,',
  boxShadow: 24,
  p: 4,
};

const card = {

  width: '350px',
  height: 'auto',
  borderRadius: 25,
  boxShadow: 3

};

function WoodDetail(props) {
  const db = getFirestore(firebaseConfig)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [addModal, setAddModal] = useState(false);
  const addHandleClose = () => setAddModal(false);
  const [modal, setModal] = useState(false);
  const [item, setItem] = useState();
  const handleOpen = () => setModal(true);
  const handleClose = () => setModal(false);

  const [open, setOpen] = useState(false);
  const [id, setId] = useState();
  const [openEdit, setOpenEdit] = useState(false);
  const closeModal = () => setOpen(false);

  const [wood, setWood] = useState([]);
  const [woodCreate, setWoodCreate] = useState(null);
  const woodCollectionRef = collection(db, "Wood");

  const deleteWood = async (id) => {
    const woodDoc = doc(db, "Wood", id);
    await deleteDoc(woodDoc);
    alert("ลบเรียบร้อย")
    window.location.reload();
  };


  useEffect(() => {
    const getWood = async () => {
      const data = await getDocs(woodCollectionRef);
      await setWood(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getWood();
  }, []);

  wood.sort(function (x, y) {
    let a = x.woodName,
        b = y.woodName;
    return a == b ? 0 : a > b ? 1 : -1;
  })

  return (
    <Container>
      <Typography variant="h1" sx={{fontWeight:'bold', fontSize:'2.25vw', marginTop:"20px", fontFamily:'Prompt'}}>จัดการข้อมูลไม้</Typography>
      <div>
        <Button style={{ float: "right", marginBottom: 10 }} 
        sx={{ fontFamily:'Prompt'}}

        onClick={() => navigate('/wood/create')}
        variant="contained" color="success" startIcon={<AddCircleOutlineIcon/>}>เพิ่ม
        </Button>
        

        
        <Grid container spacing={5}>
    {wood.map((row) => (
      <Grid item xs={4}>
      <Card style={card}>
        <CardMedia component="img" height='200vh' image={row.woodImage}/>
        <CardContent>

          <Typography variant="h1" align="left"  sx={{fontSize:'1.5vw', fontWeight:'bold', fontFamily:'Prompt'}}>
            {row.woodName}
          </Typography>
          
          <Typography variant="subtitle1" sx={{overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            '-webkit-line-clamp': '1',
            '-webkit-box-orient': 'vertical',
            color: "#8C8C8C",
            fontFamily:'Prompt'}} >
           {row.woodSName}
          </Typography>


          <Typography variant="subtitle2" sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            '-webkit-line-clamp': '3',
            '-webkit-box-orient': 'vertical',
            color:'##525252',
            fontFamily:'Prompt'

         }}>
            {row.woodDesc}
          </Typography>
        </CardContent>
         
        <CardContent>
        <Stack spacing={8} direction="row" justifyContent="center">
                  <Button
                    sx={{ fontFamily:'Prompt'}}
                    variant="text"
                    onClick={() => {
                      deleteWood(row.id);
                      }}
                      color="error" size="large" startIcon={<DeleteOutlineIcon/>}>
                    ลบ
                  </Button>
                 
                  <Button variant="contained" 
                  sx={{ fontFamily:'Prompt'}}
                  onClick={() => {
                    dispatch({
                      type:'wood',
                      payload:{
                        woodName: row.woodName,
                        woodSName: row.woodSName,
                        woodTName: row.woodTName,
                        woodLocate: row.woodLocate,
                        woodDesc: row.woodDesc,
                        woodImage: row.woodImage,
                      }
                    })
                    navigate('/wood/update/' + row.id)
                    }} 

   
                    startIcon={<EditIcon/>}>แก้ไข</Button>

                </Stack>
        </CardContent>

      </Card>
      </Grid>
    ))}
    </Grid>

      </div>


    </Container>
  );
}
export default WoodDetail;
